import { useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import { useAuth } from "../contexts/AuthContext";
import { Button } from "../components/ui/button";
import { Input } from "../components/ui/input";
import { Label } from "../components/ui/label";
import { Card, CardContent, CardDescription, CardFooter, CardHeader, CardTitle } from "../components/ui/card";
import { toast } from "sonner";
import { useTaal } from "@/contexts/TaalContext";
import Beeldmerk from "../components/Beeldmerk";

export default function RegisterPage() {
  const { t } = useTaal();
  const navigate = useNavigate();
  const { register } = useAuth();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [displayName, setDisplayName] = useState("");
  const [isLoading, setIsLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!email.trim() || !password) return;
    setIsLoading(true);
    try {
      await register(email, password, displayName);
      toast.success(t("Account aangemaakt"));
      navigate("/");
    } catch (error) {
      toast.error(error.response?.data?.detail || t("Account aanmaken mislukt"));
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-background p-4">
      <Card className="w-full max-w-sm">
        <CardHeader className="text-center">
          <div className="flex justify-center mb-2">
            <Beeldmerk className="h-10 w-10" testId="registratie-beeldmerk" />
          </div>
          <CardTitle className="font-serif text-xl">{t("Account aanmaken")}</CardTitle>
          <CardDescription>{t("Begin met Novamund")}</CardDescription>
        </CardHeader>
        <form onSubmit={handleSubmit}>
          <CardContent className="space-y-4">
            <div className="space-y-2">
              <Label htmlFor="displayName">{t("Weergavenaam")}</Label>
              <Input id="displayName" value={displayName} onChange={(e) => setDisplayName(e.target.value)} placeholder={t("Je naam")} />
            </div>
            <div className="space-y-2">
              <Label htmlFor="email">{t("E-mail")}</Label>
              <Input id="email" type="email" value={email} onChange={(e) => setEmail(e.target.value)} placeholder={t("jij@voorbeeld.nl")} required />
            </div>
            <div className="space-y-2">
              <Label htmlFor="password">{t("Wachtwoord")}</Label>
              <Input id="password" type="password" value={password} onChange={(e) => setPassword(e.target.value)} placeholder="••••••••" required />
            </div>
          </CardContent>
          <CardFooter className="flex flex-col gap-3">
            <Button type="submit" className="w-full" disabled={isLoading}>
              {isLoading ? t("Aanmaken...") : t("Account aanmaken")}
            </Button>
            <p className="text-xs text-muted-foreground">
              {t("Al een account?")} <Link to="/login" className="text-[hsl(var(--accent))] hover:underline">{t("Aanmelden")}</Link>
            </p>
            <p className="text-xs text-muted-foreground">
              <Link to="/" className="hover:underline">{t("Doorgaan zonder account")}</Link>
            </p>
          </CardFooter>
        </form>
      </Card>
    </div>
  );
}
